export enum PortfolioStorage {
  AccessToken = '@liv-prof-pfo:access-token',
  PortalToken = '@liv-prof-pfo:ptl-token',
  RunningInDevMode = '@liv-prof-pfo:dev-mode'
}
